// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__ySCTB","logo":"Navbar_logo__8Zlpy","navLinks":"Navbar_navLinks__c3eEX","navItem":"Navbar_navItem__4YN7v"};